// removed by extract-text-webpack-plugin
module.exports = {"form":"Form__form__Yv6UH","input":"Form__input__3uLxX","button":"Form__button__VlJv6"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Form/Form.css
// module id = 35
// module chunks = 0